import { Text } from '~/components/ui/Text';
import { StyledContainer } from './SectionHeading.styled';

const SectionHeading = ({ icon, text }: { icon: string; text: string }) => {
	return (
		<StyledContainer>
			<img src={icon} />
			<Text>{text}</Text>
		</StyledContainer>
	);
};

export { SectionHeading };
